import { createComponent } from '@/helpers/alpine';

const CheckoutAction = createComponent(() => ({
    init() {
        const btn = document.querySelector(
            `.js-current-step .js-submit-btn`,
        ) as HTMLButtonElement;
        const nextBtn = this.$refs.nextBtn as HTMLButtonElement;

        if (btn) {
            const observer = new MutationObserver(() => {
                nextBtn.disabled = btn.disabled;
            });

            observer.observe(btn, {
                attributes: true,
                attributeFilter: ['disabled'],
            });

            nextBtn.disabled = btn.disabled;
        }
    },

    next() {
        const btn = document.querySelector(
            `.js-current-step .js-submit-btn`,
        ) as HTMLButtonElement;
        const status = btn.getAttribute('disabled');

        if (!status) btn.click();
    },
}));

export { CheckoutAction };
